import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SharedPipesModule } from '@app/@core/pipes/shared-pipes.module';

@Component({
  selector: 'app-content-management-modal',
  standalone: true,
  imports: [MatDialogModule, CommonModule, SharedPipesModule],
  templateUrl: './content-management-modal.component.html',
  styleUrls: ['./content-management-modal.component.scss']
})
export class ContentManagementModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<ContentManagementModalComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
